import { type CODE_LANGUAGE, type FALLBACK_LANGUAGE } from "./language";

export function defineTexts<D extends TextDefinitions>(definitions: D): D {
  return definitions;
}

export type OptionalLanguage = Exclude<CODE_LANGUAGE, FALLBACK_LANGUAGE>;

export type LanguageProvided = { [key in FALLBACK_LANGUAGE]: string } & {
  [key in OptionalLanguage]?: string;
};

export type TextDefinitionFunction<T extends (number | string)[]> = (
  ...args: T
) => LanguageProvided;

export type TextDefinitions = Record<
  string,
  LanguageProvided | TextDefinitionFunction<any>
>;
